<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div>
                <div style="font-weight:bold;margin-bottom:15px">Select a checklist the standard user for this employee has access to. Check department and location settings if a checklist is not showing here.</div>
                <div style="display:flex">
                    <select v-model="checklistInput">
                        <option :value="null">Select a checklist</option>
                        <option v-for="(c, i) in allChecklists" :value="c" :key="i">{{ c.Name }}</option>
                    </select>
                    <div style="margin:5px 0 0 10px" @click="addChecklist()"><div class="btn" style="margin:0">Add</div></div>
                </div>
                
                <draggable :list="selectedChecklists" class="config-list">
                    <div v-for="(c, i) in selectedChecklists" :key="i" style="cursor:default">
                        <div><a :href="'/playbook/'+c.Slug" target="_blank">{{ c.Name }}</a></div>
                        <svg-icon icon="x" @click="removeChecklist(i)" />
                    </div>
                </draggable>

                <input style="margin-top:15px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { VueDraggableNext } from 'vue-draggable-next';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
    name: 'EditEmployeeChecklists',
    props: [ 'employeeToEdit' ],
    components: {
        draggable: VueDraggableNext,
        SvgIcon
    },
    data() {
        return {
            disableButton: false,
            allChecklists: [] as any,
            checklistInput: null as any,
            selectedChecklists: [] as any,
            loaded: false,
        }
    },
    async created() {
        while(!this.$store.state.allNodesLoaded) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        this.allChecklists = [];

        await axios.get(`${this.$store.state.apiUrl}/api/playbook/nodesforpublicuser?employeeID=${this.employeeToEdit.ID}&type=CHECKLIST`)
            .then(resp => {
                this.allChecklists = resp.data;
            })
            .catch(e => {
                alert(e?.response?.data || 'There was an error')
                console.log(e);
                this.$emit('close');
            })

        const currentSlugs = JSON.parse(this.employeeToEdit.ChecklistsJSON);
        for(const slug of currentSlugs) {
            const item = this.allChecklists.find((c: any) => {
                return c.Slug == slug;
            })
            if(item) {
                this.selectedChecklists.push(item);
            }
        }

        this.loaded = true;
    },
    methods: {
        async submit() {
            const slugs = [];
            for(const c of this.selectedChecklists) {
                slugs.push(c.Slug);
            }

            const data = {
                employeeID: this.employeeToEdit.ID,
                slugs
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/employees/checklists`, data)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        addChecklist() {
            if(!this.checklistInput) {
                return;
            }
            const existing = this.selectedChecklists.find((c: any) => {
                return c.Slug == this.checklistInput.Slug;
            })
            if(!existing) {
                this.selectedChecklists.push(this.checklistInput);
            }

            this.$forceUpdate();
        },
        removeChecklist(i: number) {
            this.selectedChecklists.splice(i, 1);
        }
    }
});
</script>
